import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NotificationsStateService } from '../../notifications/services/notifications-state.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    username: string | undefined;
    isTestEnvironment = environment.staging == true;
    isDevEnvironment = environment.production == false && environment.staging == false;
    isProdEnvironment = environment.production == true;

    constructor(protected notificationsStateService: NotificationsStateService) { }

    ngOnInit(): void {
    }
}
